const scoped = {};

// un truc qui permet de casser les dépendances circulaires
export function initUtils(vue) {
  if (!scoped.vue) {
    scoped.vue = vue;
  }
}

export default class BaseUtils {
  vue() {
    return scoped.vue;
  }
}
